import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { ThirdPartyConsent, ThirdPartyConsentAdapter } from "@secca/shared/models/thirdPartyConsent";
import { SettingsService } from "./settings.service";
import { CaseLockHttpService } from "./case-lock-http.service";
import { HttpClient } from "@angular/common/http";
import { ThirdPartyConsentStatusEnum } from "@secca/shared/models/enums";
import { map, Observable } from "rxjs";


@Injectable({
  providedIn: 'root',
})
export class ThirdPartyConsentService extends BaseService {

    constructor(
    private settingsService: SettingsService,
    private http: HttpClient,
    private caseLockHttpService: CaseLockHttpService,
    private thirdPartyConsentAdaptor: ThirdPartyConsentAdapter
  ) {
    super(settingsService);
  }

  updateThirdPartyConsent(caseId: number, consentStatus: ThirdPartyConsentStatusEnum, thirdPartyConsent: ThirdPartyConsent): Observable<ThirdPartyConsent> {
    return this.caseLockHttpService
      .post<ThirdPartyConsent>(this.baseURL + 'third-party-consent/case/' + caseId, thirdPartyConsent,  {
        headers: this.jsonHeaders,
      })
      .pipe(map(item => this.thirdPartyConsentAdaptor.adapt(item)));
  }

  getThirdPartyConsentStatus(caseId: number): Observable<ThirdPartyConsent> {
    return this.fetchThirdPartyConsentStatus(caseId);
  }

  private fetchThirdPartyConsentStatus(caseId: number): Observable<ThirdPartyConsent> {
    return this.http
      .get<ThirdPartyConsent>(this.baseURL + 'third-party-consent/case/' + caseId, { headers: this.jsonHeaders })
      .pipe(map(item => this.thirdPartyConsentAdaptor.adapt(item)));
  }


}